/* eslint-disable */
export default {
  today: '今日',
  yesterday: '昨天',
  empty: '無通話紀錄',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
